/**
 * TanStack Query hooks for `device-breakdown-widget`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	deviceBreakdownWidgetQueryKeys,
	type CreateDeviceBreakdownWidgetBody,
	type ListDeviceBreakdownWidgetResponse,
	type DeviceBreakdownWidgetRow,
} from "./api";

export function useDeviceBreakdownWidgetList(): UseQueryResult<ListDeviceBreakdownWidgetResponse, Error> {
	return useQuery({
		queryKey: deviceBreakdownWidgetQueryKeys.list(),
		queryFn: list,
	});
}

export function useDeviceBreakdownWidgetCreate(): UseMutationResult<DeviceBreakdownWidgetRow, Error, CreateDeviceBreakdownWidgetBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: deviceBreakdownWidgetQueryKeys.all });
		},
	});
}

export function useDeviceBreakdownWidgetDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: deviceBreakdownWidgetQueryKeys.all });
		},
	});
}
